import { CubeIcon, LockSimpleIcon, UsersThreeIcon } from '@phosphor-icons/react'

export const viewVisibilityIndicators = {
  predefined: {
    Icon: CubeIcon,
    label: 'Vista predefinida',
  },
  private: {
    Icon: LockSimpleIcon,
    label: 'Privada — solo tú puedes verla',
  },
  sharedWithOwnGroup: {
    Icon: UsersThreeIcon,
    label: 'Compartida con tu grupo',
  },
  sharedWithGroups: {
    Icon: UsersThreeIcon,
    label: 'Compartida con {{count}} grupos',
  },
}
